import _ from "@lodash";
import { ListItemIcon, ListItemText, Menu, MenuItem, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import React from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import AgendamentoEdicaoApp from "../AgendamentoEdicaoApp";

const styles = theme => ({
    btn: {
        backgroundColor: theme.palette.type === "dark" ? "rgb(255, 255, 255, .1)" : "rgb(0, 0, 0, .08)",
        "&:hover": {
            backgroundColor: theme.palette.type === "dark" ? "rgb(255, 255, 255, .2)" : "rgb(0, 0, 0, .18)"
        }
    }
});

class ContatoStatus extends XAPPComponent {

    state = {
        menuEl: null,
        gerandoAgendamento: null,
    };

    checkDisabled = (_AItem) => {
        const { data } = this.props;
        if (!_.isUndefined(_AItem.disabled)) {
            return (_AItem.disabled.includes(data.status));
        }
        else {
            return false;
        }
    };

    render() {
        const { data, save = null, xappRouteParams, callback = null, iconProps, classes, STATUS = [], type = "button", className } = this.props;
        const form = this.state;
        let AStatus = { "icon": "calendar", "label": "Status" };
        if (_.findIndex(STATUS, { id: data.status }) !== -1) {
            AStatus = _.find(STATUS, { id: data.status });
        }
        return (
            <React.Fragment>
                <div className={clsx("flex flex-row", className)} onClick={ev => ev.stopPropagation()}>
                    <XAPPButton
                        tooltip={type === "icon" && { "title": AStatus.label, "placement": "top" }}
                        type={type}
                        className={clsx(type === "button" && classes.btn, type === "icon" ? "p-6" : "p-2", "shadow-none capitalize mr-4")}
                        variant="contained"
                        color="textSecondary"
                        onClick={(ev) => {
                            ev.stopPropagation();
                            this.setState(_.set({ ...this.state }, "menuEl", ev.currentTarget));
                        }}
                        iconProps={clsx(iconProps, type === "icon" && AStatus.cor, type === "button" && "mr-8")}
                        icon={AStatus.icon}
                        label={type === "button" && (AStatus.label)}
                    >
                        {type === "button" &&
                            <MdKeyboardArrowDown className="ml-4 text-20 " />
                        }
                    </XAPPButton>
                    <Menu
                        id="label-menu"
                        anchorEl={form.menuEl}
                        open={Boolean(form.menuEl)}
                        onClose={(ev) => {
                            ev.stopPropagation();
                            this.setState(_.set({ ...this.state }, "menuEl", null));
                        }}
                    >
                        {STATUS.map(item => (
                            <MenuItem
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    if (!_.isNull(save)) {
                                        save({
                                            idtarefaprocesso: data.idtarefaprocesso,
                                            idagendamento: data.idagendamento,
                                            idagendamentopessoaformulario: data.idagendamentopessoaformulario,
                                            status: item
                                        }, xappRouteParams, "ALTERARSTATUS");
                                    }
                                    this.setState(_.set({
                                        ...this.state,
                                        "menuEl": null,
                                        "gerandoAgendamento": item.id === 12 ? {
                                            ...data,
                                            clientes: data.clientesLookup ?? data.clientes,
                                            responsaveis: data.responsaveisLookup ?? data.responsaveis,
                                        } : null
                                    }));
                                }}
                                key={"MenuItem_" + item.label}
                                disabled={this.checkDisabled(item)}
                            >
                                <ListItemIcon className="m-0">
                                    < XAPPButton
                                        type="icon"
                                        variant="contained"
                                        className="p-0"
                                        color="textSecondary"
                                        onClick={(ev) => ev.stopPropagation()}
                                        icon={item.icon}
                                    />
                                </ListItemIcon>
                                <ListItemText primary={item.label} disableTypography={true} />
                            </MenuItem>
                        ))}
                    </Menu>
                    {!_.isNull(form.gerandoAgendamento) &&
                        <AgendamentoEdicaoApp
                            xappRouteParams={xappRouteParams}
                            callback={() => {
                                this.setState(_.set({ ...this.state, "menuEl": null, "gerandoAgendamento": null }));
                                if (!_.isNull(callback)) {
                                    callback();
                                }
                            }}
                            view={"Agendamento"}
                            isDialog={true}
                            idparent={form.gerandoAgendamento.idagendamento}
                            openAutomatic={true}
                            key={"Agendamento_New_Agendamento"}
                            tipo={1}
                            sugerido={{
                                agendamentotag: form.gerandoAgendamento.agendamentotag,
                                preatendimento: form.gerandoAgendamento.preatendimento,
                                clientes: form.gerandoAgendamento.clientes,
                                responsaveis: form.gerandoAgendamento.responsaveis,
                            }}
                            idagendamento={"new_Agendamento"}
                        />
                    }
                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(ContatoStatus);